<template>
  <div class="quoteDraft">
    <div v-if="firstTimeLoading" data-cy="loadingPrograms">
      <h4 class="mb-2">Financing Options</h4>
      <Card headless>
        <div class="d-flex align-items-center">
          <Spinner2
            class="ml-auto mr-auto"
            :size="40"
            color="primary"
            message="Loading Available Programs..."
          />
        </div>
      </Card>
    </div>
    <div v-else class="sections">
      <div v-if="financingOptionsActive">
        <h4 class="mb-3">Financing Options</h4>
        <FinancingOffers data-cy="financingOffers" />
      </div>
      <div v-if="paymentsAsLowAsEnabled">
        <h4 class="mb-2">Custom Financing</h4>
        <Card headless no-shadow>
          <AdditionalFinancing data-cy="additionalFinancing" />
        </Card>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import Card from "@/components/Card.vue";
import Spinner2 from "@/components/Spinner2.vue";
import AdditionalFinancing from "./AdditionalFinancing.vue";
import FinancingOffers from "./FinancingOffers.vue";
import { useFinancingAvailable } from "./useFinancingAvailable";

const { paymentsAsLowAsEnabled, firstTimeLoading, financingOptionsActive } =
  useFinancingAvailable();
</script>

<style lang="scss" scoped>
.quoteDraft {
  background: #ededed;
  margin-top: 0.5rem;
  padding: 16px;
  .sections > *:not(:last-child) {
    margin-bottom: 20px;
  }
}
</style>
